import {
  FormControlLabel,
  Grid,
  Typography,
  WithStyles,
  makeStyles,
  Checkbox
  //CircularProgress
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { useState, useEffect } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import {
  ReduxFormField,
  ReduxCheckbox,
  ReduxDatePicker
} from '../../../components/FormInput/ReduxWrappers'
// import TermsFrame from '../../../components/TernsFrame/TermsFrame'
import {
  onlyNumsAndDecimals
} from '../../../libs/normalize/information'
import {
  selectApartmentById,
  selectBeforeLoginApartment
} from '../../../selectors/apartments'
import { selectContentIdFromPathname } from '../../../selectors/router'
import { selectIsMobile } from '../../../selectors/users'
import { ReduxForm } from '../../../types/forms'
import {
  WaterFeeBasis,
  RentPeriodOptions,
  SecurityDepositOptions,
  NoticeTimeOptions,
  Parking
} from '../../../types/propValues/apartments'
// import { ShowingTypes } from '../../../types/showings'
import { StateInterface } from '../../../types/states'

import {
  required,
  // requiredFalsyString,
  greaterThanAvailableFrom,
  noSpacesPhoneNum,
  validateEmail,
  validatePassword,
  noSpaceValue,
  validatePhoneNumber,
  isInvalidCharacters
} from '../../../utils/validation/forms'
import { MyApartmentRadio, MyInput } from '../../NewApplication/Fields'
import { BackButton } from '../Stepper/BackButton'
import NextStepButton from '../Stepper/NextStepButton'
import Suggest from '../Stepper/Steps/Suggest'
import SubmitButton from '../Stepper/SubmitButton'
import { getValuesAndLabels } from './values/apartmentProperties'

const useStyles = makeStyles({
  Accordion: {
    marginTop: '15px'
  },
  panelDetails: {
    display: 'block',
    height: '300px',
    padding: 0,
    overflow: 'hidden'
  },
  panelTitle: {
    marginTop: '15px',
    backgroundColor: '#bdbdbd'
  },
  confirmRow: {
    '& > label': {
      alignItems: 'start'
    }
  },
  checkboxes: {
    marginLeft: '0',
    marginRight: '0',
    alignItems: 'start',
    '& > div': {
      marginTop: '-7px',
      alignSelf: 'center',
      paddingLeft: '10px'
    },
    '& > span': {
      paddingBottom: '15px'
    },
    '& label': {
      marginRight: '6px'
    }
  },
  confirmField: {
    //marginTop: '16px !important',
    color: 'rgb(79, 155, 68)',
    marginRight: '7px',
    marginLeft: '-1px'
  },
  confirmTextDiv: {
    padding: '25px 0 10px 0'
  },
  toMarketingCheckBoxContainer: {
    alignItems: 'center !important',
    marginTop: '-1.3rem',
  },
  vuokraoviCollateralCheckBoxContainer: {
    alignItems: 'center !important',
    marginBottom: '-1.3rem'
  }
})
interface ApartmentConfirmationFormProps
  extends WithStyles,
  WithTranslation,
  ReduxForm {
  updateApartmentConfirmation: (arg: any) => any
  isDisabled: boolean
  isTemporaryRentPeriod: boolean
  isFormerlyValid: boolean
  waterFeeBasis: WaterFeeBasis | undefined
  waterFeeAdornment: string
  rentPrice: number
  rentPeriod: string
  confirm: boolean
  securityDeposit: string
  showParkingFee: boolean
  showSecurityDepositAmount: boolean
  isSVAMember: boolean
  isBeforeLogin?: boolean
  createdAt: number | undefined
  currentStep: any
  doStepBack: any
  isMobile: any
  beforeLogin?: boolean
  notes?: string
  availableUntilDate?: any
  availableFromDate?: any
  vuokraoviCollateral?: boolean
  name: string
  phoneNumber: string
  email: string
  password: string
}

// const getWaterFeeAdornment = (waterFeeBasis: WaterFeeBasis) => {
//   const abbreviation =
//     waterFeeBasis === 'perTenant' || waterFeeBasis === 'metered'
//       ? 'perPersonPerMonth'
//       : 'perMonth'
//   return `€${i18n.t(`abbreviations.${abbreviation}`)}`
// }

export const showParking = (parking: Parking | undefined): boolean =>
  parking ? parking !== 'no' && parking !== 'notSure' : false

const ApartmentConfirmationForm = ({
  t,
  handleSubmit,
  submitting,
  error,
  updateApartmentConfirmation,
  classes,
  isDisabled,
  isTemporaryRentPeriod,
  isFormerlyValid,
  waterFeeBasis,
  showParkingFee,
  rentPrice,
  rentPeriod,
  securityDeposit,
  showSecurityDepositAmount,
  confirm,
  isSVAMember,
  isBeforeLogin,
  createdAt,
  doStepBack,
  currentStep,
  isMobile,
  beforeLogin,
  notes,
  availableUntilDate,
  availableFromDate,
  name,
  phoneNumber,
  email,
  password,
  vuokraoviCollateral
}: ApartmentConfirmationFormProps) => {
  const styles = useStyles()
  const [isEmpty, setIsEmpty] = useState(false)
  const [toMarketing, setToMarketing] = useState(false)
  const [vuokraoviCollateralAccepted, setVuokraoviCollateralAccepted] = useState(false)

  // useEffect(() => {
  //   if (beforeLogin) {
  //     const storedValue = localStorage.getItem('toMarketing');
  //     if (storedValue === null) {
  //       localStorage.setItem('toMarketing', 'true');
  //     } else {
  //       setToMarketing(storedValue === 'true');
  //     }
  //   }
  // }, [beforeLogin]);

  const handleToMarketingCheckboxChange = (event) => {
    const isChecked = event.target.checked
    setToMarketing(isChecked)

    if (isChecked) {
      localStorage.setItem('toMarketing', 'true')
    } else {
      localStorage.removeItem('toMarketing')
    }
  }

  const handleVuokraoviCollateralAcceptedCheckboxChange = (event) => {
    const isChecked = event.target.checked
    setVuokraoviCollateralAccepted(isChecked)

    if (isChecked) {
      localStorage.setItem('vuokraoviCollateral', 'true')
    } else {
      localStorage.setItem('vuokraoviCollateral', 'false')
    }
  }

  useEffect(() => {
    if (vuokraoviCollateral === true) {
      setVuokraoviCollateralAccepted(true)
      localStorage.setItem('vuokraoviCollateral', 'true')
    } else {
      setVuokraoviCollateralAccepted(false)
      localStorage.setItem('vuokraoviCollateral', 'false')
    }
  }, [vuokraoviCollateral])

  return (
    <form onSubmit={handleSubmit(updateApartmentConfirmation)}>
      <Grid container justify='space-between'>
        <Grid container>
          {currentStep === 9 && (
            <>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step9heading')}
                      </Typography>
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.rentPeriod.label')}
                      </Typography>
                      <ReduxFormField
                        name='rentPeriod'
                        select
                        required
                        component={MyApartmentRadio}
                        validate={[required]}
                        disabled={isDisabled}
                        style={{ width: '90%' }}
                        items={getValuesAndLabels(
                          RentPeriodOptions,
                          'rentPeriod'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    {isFormerlyValid && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className={classes.containerItem}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.rentPeriod.noticeTime')}
                        </Typography>
                        {/* <Field
                          fullWidth
                          name='noticeTime'
                          required
                          style={{
                            width: '100%',
                            height: '58px',
                            padding: '20px',
                            background: '#E7ECEF'
                          }}
                          component={MyInput}
                          normalize={charsSpaceNums}
                        /> */}
                        <ReduxFormField
                          name='noticeTime'
                          select
                          component={MyApartmentRadio}
                          required
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            NoticeTimeOptions,
                            'noticeTime'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                    )}
                    {isTemporaryRentPeriod && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className={classes.containerItem}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.availableUntilDate')}
                        </Typography>
                        <Grid item xs={12} className={classes.datePicker}>
                          <DateRangeIcon />
                          <Field
                            fullWidth
                            name='availableUntilDate'
                            invalidLabel=''
                            required
                            validate={[required, greaterThanAvailableFrom]}
                            component={ReduxDatePicker}
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.securityDeposit.label')}
                      </Typography>
                      <ReduxFormField
                        name='securityDeposit'
                        select
                        component={MyApartmentRadio}
                        required
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          SecurityDepositOptions,
                          'securityDeposit'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    {showSecurityDepositAmount && (
                      <Grid item xs={12} sm={12}>
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.securityDepositAmount')}
                        </Typography>
                        <ReduxFormField
                          name='securityDepositAmount'
                          required
                          InputProps={{ min: 0, step: 0.01, endAdornment: '€' }}
                          disabled={isDisabled}
                          component={MyInput}
                          style={{
                            width: '100%',
                            height: '58px',
                            padding: '20px',
                            background: '#E7ECEF'
                          }}
                          type='number'
                          normalize={onlyNumsAndDecimals}
                          validate={[required]}
                        />
                      </Grid>
                    )}
                    {/* <Grid item xs={12} sm={12}>
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.rentPrice')}
                      </Typography>
                      <ReduxFormField
                        name='price'
                        required
                        InputProps={{ min: 0, step: 0.01, endAdornment: '€' }}
                        disabled={isDisabled}
                        component={MyInput}
                        style={{
                          width: '100%',
                          height: '58px',
                          padding: '20px',
                          background: '#E7ECEF'
                        }}
                        type='number'
                        normalize={onlyNumsAndDecimals}
                        validate={[required]}
                      />
                    </Grid> */}
                    <FormControlLabel
                      className={`${styles.checkboxes} ${styles.vuokraoviCollateralCheckBoxContainer}`} // Add styles from ReduxCheckbox
                      control={
                        <Checkbox
                          checked={vuokraoviCollateralAccepted}
                          onChange={handleVuokraoviCollateralAcceptedCheckboxChange}
                          style={{ color: '#4f9b44' }} // Custom color as needed
                          className={styles.confirmField} // Apply any specific styles for Checkbox
                        //disabled={isDisabled}
                        />
                      }
                      label={
                        <div className={styles.confirmTextDiv}>
                          {t('apartment.vuokraoviCollateralCheckboxText')}
                        </div>
                      }
                    />
                  </Grid>
                  {isEmpty && (
                    <Typography style={{ color: 'red' }} variant='body1'>
                      {t('apartment.actions.stepFail')}
                    </Typography>
                  )}
                  <Grid container className={classes.buttonContainer}>
                    <Grid item xs={4}>
                      <BackButton
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <NextStepButton
                        type='button'
                        beforeLogin={beforeLogin}
                        toValidate={{
                          rentPeriod: rentPeriod,
                          securityDeposit: securityDeposit
                        }}
                        toCheck={{
                          availableUntilDate: availableUntilDate
                            ? availableUntilDate['_d'] < availableFromDate
                            : ''
                        }}
                        setIsEmpty={setIsEmpty}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid sm={6} xs={12}>
                  <div style={{ float: 'right' }}>
                    <Suggest
                      content={t('apartment.hints.step9Hint')}
                      containerMaxWidth='550px'
                      contentMaxWidth='450px'
                    />
                  </div>
                </Grid>
              </Grid>{' '}
            </>
          )}

          {currentStep === 10 && (
            <>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <Grid className={classes.largeForm} container>
                    {' '}
                    <Typography variant='h5' gutterBottom>
                      {beforeLogin
                        ? t('apartment.steps.step10heading')
                        : t('apartment.additionalInfo')}
                    </Typography>
                    <Grid item container xs={12}>
                      <Grid container spacing={1}>
                        {beforeLogin && (
                          <>
                            <Grid item sm={12}>
                              <Typography variant='subtitle2' gutterBottom>
                                {t('signup.passwordHelper')}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('apartment.list.confirmation.notes')}
                              </Typography>
                              <ReduxFormField
                                name='notes'
                                type='text'
                                component={MyInput}
                                validate={[isInvalidCharacters]}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                multiline={true}
                                disabled={isDisabled}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.fullName')}
                              </Typography>
                              <ReduxFormField
                                name='name'
                                validate={[required, isInvalidCharacters]}
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                required
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.phoneNum')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='tel'
                                name='phoneNumber'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                validate={[
                                  required,
                                  noSpacesPhoneNum,
                                  validatePhoneNumber,
                                ]}
                                required
                              />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.email')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='username'
                                name='email'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                validate={[
                                  required,
                                  noSpaceValue,
                                  validateEmail
                                ]}
                                required
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.password')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='new-password'
                                name='password'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                type='password'
                                helperText={t('changePw.helperText')}
                                validate={[
                                  required,
                                  validatePassword,
                                  noSpaceValue
                                ]}
                                required
                              />
                            </Grid>
                          </>
                        )}
                        {!beforeLogin && (
                          <Grid item xs={12}>
                            <Typography variant='body1' gutterBottom>
                              {t('apartment.list.confirmation.notes')}
                            </Typography>
                            <ReduxFormField
                              name='notes'
                              type='text'
                              component={MyInput}
                              style={{
                                width: '100%',
                                height: '58px',
                                padding: '20px',
                                background: '#E7ECEF'
                              }}
                              validate={[isInvalidCharacters]}
                              multiline={true}
                              disabled={isDisabled}
                            />
                          </Grid>
                        )}

                        <Grid
                          item
                          xs={12}
                          sm={12}
                          className={styles.confirmRow}
                        >
                          <FormControlLabel
                            className={`${styles.checkboxes}`}
                            control={
                              <Field
                                //className={styles.confirmField}
                                name='confirm'
                                color='primary'
                                component={ReduxCheckbox}
                                disabled={isDisabled}
                              />
                            }
                            label={
                              <div className={styles.confirmTextDiv}>
                                {t('apartment.confirmation.confirmPart')}
                                <a
                                  style={{
                                    textDecoration: 'none',
                                    color: 'inherit'
                                  }}
                                  target='blank'
                                  href='https://fiksuvuokraus.fi/kayttoehdot/'
                                >
                                  {t('apartment.confirmation.confirmPartLink1')}
                                </a>
                                {t('apartment.confirmation.confirmDivider')}
                                <a
                                  style={{
                                    textDecoration: 'none',
                                    color: 'inherit'
                                  }}
                                  target='blank'
                                  href='https://fiksuvuokraus.fi/tietosuojaseloste/'
                                >
                                  {t('apartment.confirmation.confirmPartLink2')}
                                </a>
                              </div>
                            }
                          />
                          {beforeLogin && (
                            <FormControlLabel
                              className={`${styles.checkboxes} ${styles.toMarketingCheckBoxContainer}`} // Add styles from ReduxCheckbox
                              control={
                                <Checkbox
                                  checked={toMarketing}
                                  onChange={handleToMarketingCheckboxChange}
                                  style={{ color: '#4f9b44' }} // Custom color as needed
                                  className={styles.confirmField} // Apply any specific styles for Checkbox
                                //disabled={isDisabled}
                                />
                              }
                              label={
                                <div className={styles.confirmTextDiv}>
                                  {t('apartment.toMarketingDisclaimer')}
                                  <a
                                    style={{
                                      textDecoration: 'none',
                                      color: 'inherit'
                                    }}
                                    target='blank'
                                    href='https://fiksuvuokraus.fi/kayttoehdot'
                                  >
                                    {t('apartment.confirmation.confirmPartLinkToMarketing')}
                                  </a>
                                </div>
                              }
                            />
                          )}
                        </Grid>
                      </Grid>
                      {showParkingFee && (
                        <Grid item xs={12} lg={6}>
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.parkingFee')}
                          </Typography>
                          <ReduxFormField
                            name='parkingFee'
                            type='number'
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            InputProps={{
                              min: 0,
                              step: 0.01,
                              endAdornment: '€'
                            }}
                            normalize={onlyNumsAndDecimals}
                            disabled={isDisabled}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid item sm={12} xs={12} style={{ marginTop: '15px' }}>
                      <ErrorMessage error={error} />
                      <Grid container>
                        <Grid item xs={4}>
                          <BackButton
                            currentStep={currentStep}
                            doStepBack={doStepBack}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <SubmitButton
                            t={t}
                            submit={!isDisabled}
                            setIsEmpty={setIsEmpty}
                            toCheck={{
                              notes: isInvalidCharacters(notes),
                              name: isInvalidCharacters(name),
                              phoneNumber:
                                noSpacesPhoneNum(phoneNumber) ||
                                validatePhoneNumber(phoneNumber),
                              email:
                                noSpaceValue(email) || validateEmail(email),
                              password:
                                validatePassword(password) ||
                                noSpaceValue(password)
                            }}
                            externalIsLoading={submitting}
                            customLabel={
                              <> {t('apartment.actions.confirm')}</>
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid sm={6} xs={12}>
                  <div style={{ float: 'right' }}>
                    <Suggest
                      content={t('apartment.hints.step10Hint')}
                      containerMaxWidth='550px'
                      contentMaxWidth='450px'
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>{' '}
    </form>
  )
}

const selector = formValueSelector('ApartmentConfirmationForm')

const mapStateToProps = (
  state: StateInterface,
  ownProps: { isBeforeLogin: boolean }
) => {
  let apartment
  if (ownProps.isBeforeLogin) {
    apartment = selectBeforeLoginApartment(state)
  } else {
    const apartmentId = selectContentIdFromPathname(state)
    apartment = apartmentId
      ? selectApartmentById(apartmentId)(state)
      : undefined
  }
  const isSVAMemberValue = selector(state, 'isSVAMember')
  return {
    isTemporaryRentPeriod: selector(state, 'rentPeriod') === 'temporary',
    isFormerlyValid: selector(state, 'rentPeriod') === 'formerlyValid',
    waterFeeBasis: selector(state, 'waterFeeBasis'),
    showSecurityDepositAmount: selector(state, 'securityDeposit') === 'other',
    rentPrice: Number(apartment?.switchedData?.price || '0'),
    rentPeriod: selector(state, 'rentPeriod'),
    availableUntilDate: selector(state, 'availableUntilDate'),
    availableFromDate: selector(state, 'availableFromDate'),
    notes: selector(state, 'notes'),
    confirm: selector(state, 'confirm'),
    securityDeposit: selector(state, 'securityDeposit'),
    showParkingFee: showParking(apartment?.information?.parking),
    isSVAMember: isSVAMemberValue === true || isSVAMemberValue === 'true',
    isMobile: selectIsMobile(state),
    name: selector(state, 'name'),
    phoneNumber: selector(state, 'phoneNumber'),
    email: selector(state, 'email'),
    password: selector(state, 'password')
  }
}

export default connect(mapStateToProps)(
  reduxForm({
    form: 'ApartmentConfirmationForm'
  })(withTranslation()(ApartmentConfirmationForm as any) as any) as any
) as any
